import './LegalPage.css'

export default function Datenschutz() {
  return (
    <div className="legal-page">
      <div className="container container--narrow">
        <h1>Datenschutzerklärung</h1>

        <section className="legal-section">
          <h2>1. Datenschutz auf einen Blick</h2>
          <h3>Allgemeine Hinweise</h3>
          <p>
            Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren 
            personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene 
            Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.
          </p>

          <h3>Datenerfassung auf dieser Website</h3>
          <p>
            <strong>Wer ist verantwortlich für die Datenerfassung auf dieser Website?</strong><br />
            Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen 
            Kontaktdaten können Sie dem Impressum dieser Website entnehmen.
          </p>
          <p>
            <strong>Wie erfassen wir Ihre Daten?</strong><br />
            Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann 
            es sich z.B. um Daten handeln, die Sie in ein Kontaktformular eingeben oder über unser 
            Wechselprofil-Formular angeben.
          </p>
          <p>
            Andere Daten werden automatisch oder nach Ihrer Einwilligung beim Besuch der Website 
            durch unsere IT-Systeme erfasst. Das sind vor allem technische Daten (z.B. Internetbrowser, 
            Betriebssystem oder Uhrzeit des Seitenaufrufs).
          </p>
        </section>

        <section className="legal-section">
          <h2>2. Hosting</h2>
          <p>
            Diese Website wird bei Vercel Inc. gehostet. Details entnehmen Sie der 
            Datenschutzerklärung von Vercel:{' '}
            <a href="https://vercel.com/legal/privacy-policy" target="_blank" rel="noopener noreferrer">
              https://vercel.com/legal/privacy-policy
            </a>
          </p>
        </section>

        <section className="legal-section">
          <h2>3. Allgemeine Hinweise und Pflichtinformationen</h2>
          <h3>Datenschutz</h3>
          <p>
            Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. 
            Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend den gesetzlichen 
            Datenschutzvorschriften sowie dieser Datenschutzerklärung.
          </p>

          <h3>Hinweis zur verantwortlichen Stelle</h3>
          <p>
            Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:<br /><br />
            Medilane<br />
            Schlehenweg 6<br />
            53177 Bonn<br />
            E-Mail: info@medi-lane.de
          </p>

          <h3>Speicherdauer</h3>
          <p>
            Soweit innerhalb dieser Datenschutzerklärung keine speziellere Speicherdauer genannt 
            wurde, verbleiben Ihre personenbezogenen Daten bei uns, bis der Zweck für die 
            Datenverarbeitung entfällt.
          </p>

          <h3>Widerruf Ihrer Einwilligung zur Datenverarbeitung</h3>
          <p>
            Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen Einwilligung möglich. 
            Sie können eine bereits erteilte Einwilligung jederzeit widerrufen. Die Rechtmäßigkeit 
            der bis zum Widerruf erfolgten Datenverarbeitung bleibt vom Widerruf unberührt.
          </p>

          <h3>Recht auf Datenübertragbarkeit</h3>
          <p>
            Sie haben das Recht, Daten, die wir auf Grundlage Ihrer Einwilligung oder in Erfüllung 
            eines Vertrags automatisiert verarbeiten, an sich oder an einen Dritten in einem 
            gängigen, maschinenlesbaren Format aushändigen zu lassen.
          </p>

          <h3>Auskunft, Löschung und Berichtigung</h3>
          <p>
            Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen jederzeit das Recht auf 
            unentgeltliche Auskunft über Ihre gespeicherten personenbezogenen Daten, deren Herkunft 
            und Empfänger und den Zweck der Datenverarbeitung und ggf. ein Recht auf Berichtigung 
            oder Löschung dieser Daten.
          </p>
        </section>

        <section className="legal-section">
          <h2>4. Datenerfassung auf dieser Website</h2>

          <h3>Kontaktformular</h3>
          <p>
            Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem 
            Formular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der 
            Anfrage und für den Fall von Anschlussfragen bei uns gespeichert. Diese Daten geben 
            wir nicht ohne Ihre Einwilligung weiter.
          </p>
          <p>
            Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO, 
            sofern Ihre Anfrage mit der Erfüllung eines Vertrags zusammenhängt oder zur 
            Durchführung vorvertraglicher Maßnahmen erforderlich ist.
          </p>

          <h3>Wechselprofil (Pflegekräfte-Funnel)</h3>
          <p>
            Wenn Sie über unsere Plattform ein Wechselprofil erstellen, werden die von Ihnen 
            angegebenen Daten (Qualifikation, Wünsche, Prioritäten, Wechselgründe, Kontaktdaten) 
            gespeichert und zur Vermittlung passender Arbeitgeber verwendet.
          </p>
          <p>
            Ihre Daten werden ausschließlich anonymisiert an potenzielle Arbeitgeber weitergegeben. 
            Eine Weitergabe Ihrer Kontaktdaten erfolgt nur nach Ihrer ausdrücklichen Zustimmung.
          </p>
          <p>
            Rechtsgrundlage ist Art. 6 Abs. 1 lit. a DSGVO (Einwilligung) sowie Art. 6 Abs. 1 
            lit. b DSGVO (vorvertragliche Maßnahmen).
          </p>
        </section>

        <section className="legal-section">
          <h2>5. Analyse-Tools und Werbung</h2>
          
          <h3>Google Ads</h3>
          <p>
            Diese Website nutzt Google Ads Conversion-Tracking. Anbieter ist die Google Ireland 
            Limited, Gordon House, Barrow Street, Dublin 4, Irland.
          </p>
          <p>
            Mit Hilfe von Google Ads Conversion-Tracking können wir erkennen, wie viele Nutzer 
            auf unsere Anzeigen geklickt und welche Aktionen sie auf unserer Website durchgeführt 
            haben. Die dabei erhobenen Informationen werden auf Servern von Google gespeichert.
          </p>
          <p>
            Rechtsgrundlage ist Art. 6 Abs. 1 lit. a DSGVO (Einwilligung).
          </p>
        </section>

        <section className="legal-section">
          <h2>6. Externe Dienste</h2>

          <h3>Web3Forms</h3>
          <p>
            Zur Übermittlung der Kontaktformular-Anfragen nutzen wir den Dienst Web3Forms
            (Codewithyou Pty Ltd). Die Anfragedaten werden ausschließlich zur Zustellung
            per E-Mail an uns verarbeitet und nicht dauerhaft gespeichert. Mehr Informationen
            finden Sie unter:{' '}
            <a href="https://web3forms.com/privacy-policy" target="_blank" rel="noopener noreferrer">
              https://web3forms.com/privacy-policy
            </a>
          </p>

          <h3>Google Fonts</h3>
          <p>
            Diese Seite nutzt zur einheitlichen Darstellung von Schriftarten so genannte Google 
            Fonts, die von Google bereitgestellt werden. Beim Aufruf einer Seite lädt Ihr Browser 
            die benötigten Fonts in ihren Browsercache, um Texte und Schriftarten korrekt anzuzeigen.
          </p>
        </section>

        <section className="legal-section">
          <h2>7. Ihre Rechte</h2>
          <p>Sie haben folgende Rechte bezüglich Ihrer personenbezogenen Daten:</p>
          <ul>
            <li>Recht auf Auskunft (Art. 15 DSGVO)</li>
            <li>Recht auf Berichtigung (Art. 16 DSGVO)</li>
            <li>Recht auf Löschung (Art. 17 DSGVO)</li>
            <li>Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
            <li>Recht auf Datenübertragbarkeit (Art. 20 DSGVO)</li>
            <li>Recht auf Widerspruch (Art. 21 DSGVO)</li>
          </ul>
          <p>
            Zur Ausübung Ihrer Rechte wenden Sie sich bitte an: info@medi-lane.de
          </p>
        </section>

        <section className="legal-section">
          <p className="legal-updated">
            Stand: April 2026
          </p>
        </section>
      </div>
    </div>
  )
}
